const { DateTime } = require("luxon");

export function dateToISO(date) {
  if (!date) { return undefined }
  const dateObject = DateTime.fromISO(date.substring(0,10));
  const dateString = dateObject.toLocaleString(DateTime.DATE_FULL)
  return dateString;
}